import { Chain } from './index';
export class WebpUrl {
    constructor() {
        this._webpWhiteLists = [
            'ut-static.udache.com',
            'dpubstatic.udache.com',
            'img-hxy021.didistatic.com',
            'gift-static.hongyibo.com.cn'
        ];
        this.opts = {};
    }
    getWebpUrl(url, opts) {
        const setOpts = new Chain(this.setOpts.bind(this));
        const hasUrl = new Chain(this.hasUrl.bind(this));
        const checkWebp = new Chain(this.checkWebp.bind(this));
        const hasSuffix = new Chain(this.hasSuffix.bind(this));
        const isWebp = new Chain(this.isWebp.bind(this));
        const returnWebp = new Chain(this.returnWebp.bind(this));
        setOpts.setNextNode(hasUrl);
        hasUrl.setNextNode(checkWebp);
        checkWebp.setNextNode(hasSuffix);
        hasSuffix.setNextNode(isWebp);
        isWebp.setNextNode(returnWebp);
        const newUrl = setOpts.passRequest(url, opts);
        return newUrl;
    }
    setOpts(url, opts) {
        this.opts = Object.assign({
            force: false
        }, opts);
        return 'next';
    }
    hasUrl(url) {
        return !url ? url : 'next';
    }
    checkWebp(url) {
        return 'next';
    }
    hasSuffix(url) {
        return url.endsWith('.gif') || url.endsWith('.GIF') || url.includes('_apng') || url.includes('no_webp') || url.endsWith('.apng') || url.endsWith('.svg') ? url : 'next';
    }
    isWebp(url) {
        return url.includes('x-s3-process=image/format,webp') ? url : 'next';
    }
    returnWebp(url) {
        const { force } = this.opts;
        const webpImgUrl = url.indexOf('?') > -1 ? `${url}&x-s3-process=image/format,webp` : `${url}?x-s3-process=image/format,webp`;
        if (force)
            return webpImgUrl;
        if (this._webpWhiteLists.every(domain => url.indexOf(domain) === -1))
            return url;
        return webpImgUrl;
    }
}
